// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"46dc3e92","455":"9b0634cb","977":"2e3d5464"}[chunkId] + ".chunk.js";
};